import { logEvent, setUserId } from "firebase/analytics";
import type { CatalogArticleItem } from "../common/types/Storyblok";
import { analytics } from "../Firebase";
import type { Attributes, LMTEvent, LMTScreen } from "../types/Analytics";
import { debounce } from "./ratelimit.util";

function debugLog(event: LMTEvent, attributes: Partial<Attributes>) {
    if (import.meta.env.NODE_ENV === "development") {
        console.log("analytics", event, attributes);
    }
}

export function setAnalyticsUserId(agent: string) {
    setUserId(analytics, agent);
}

type ScreenViewProps = {
    name: LMTScreen;
    partialAttributes: Partial<Attributes>;
};

export const logScreenView = debounce<ScreenViewProps>(
    ({ name, partialAttributes }: ScreenViewProps) => {
        const event: LMTEvent = "screen_view";
        const attributes: Partial<Attributes> = {
            firebase_screen: name,
            firebase_screen_class: name,
            ...partialAttributes,
        };

        debugLog(event, attributes);

        const { firebase_screen, firebase_screen_class, ...rest } = attributes;

        /*
         * To satisfy function logEvent overload type
         * firebase_screen and firebase_screen_class are needed here explicitly
         * */
        logEvent(analytics, event, {
            firebase_screen,
            firebase_screen_class,
            ...rest,
        });
    },
);

export function logSharedArticles(
    article: CatalogArticleItem,
    member: string,
    agent: string,
) {
    const { content, uuid, slug } = article;
    const event: LMTEvent = "lmt_article_shared_to_member";
    const attributes: Partial<Attributes> = {
        lmt_a_article_id: uuid,
        lmt_a_article_name: content.title,
        lmt_a_article_slug: slug,
        lmt_a_agent: agent,
        lmt_a_member: member,
    };

    debugLog(event, attributes);
    logEvent(analytics, event, attributes);
}
